// extracted by mini-css-extract-plugin
export var dark = "v_s2";
export var darkcookie = "v_s3";
export var tintedcookie = "v_s4";
export var regularcookie = "v_s5";
export var darkbase = "v_s6";
export var tintedbase = "v_s7";
export var regularbase = "v_s8";
export var darkraw = "v_s9";
export var tintedraw = "v_tb";
export var regularraw = "v_tc";
export var darkchick = "v_td";
export var tintedchick = "v_tf";
export var regularchick = "v_tg";
export var darkherbarium = "v_th";
export var tintedherbarium = "v_tj";
export var regularherbarium = "v_tk";
export var darkholiday = "v_tl";
export var tintedholiday = "v_tm";
export var regularholiday = "v_tn";
export var darkoffline = "v_tp";
export var tintedoffline = "v_tq";
export var regularoffline = "v_tr";
export var darkorchid = "v_ts";
export var tintedorchid = "v_tt";
export var regularorchid = "v_tv";
export var darkpro = "v_tw";
export var tintedpro = "v_tx";
export var regularpro = "v_ty";
export var darkrose = "v_tz";
export var tintedrose = "v_tB";
export var regularrose = "v_tC";
export var darktimes = "v_tD";
export var tintedtimes = "v_tF";
export var regulartimes = "v_tG";
export var darkwagon = "v_tH";
export var tintedwagon = "v_tJ";
export var regularwagon = "v_tK";